import { React, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import axios from "axios";
import PropTypes from "prop-types";
import { EventEdit } from "..";
import { Dialog, DialogTitle } from "@mui/material";
import { Star as StarIcon, Room as RoomIcon, StarBorder as StarBorderIcon, RestartAlt as RestartAltIcon, Close as CloseIcon } from "@mui/icons-material";
import "../../styles/EventTable.css";
import { localDate } from "../Utils/DateHelpers";

function EventTable(props) {
  const {
    events,
    currEvent,
    setcurrEvent,
    username,
    userType,
    updateTable,
    setUpdateTable,
    updateOffset,
    setEventOffset,
    handleChange,
    setHandleChange,
    currentPage,
    setCurrentPage,
    editedTable,
    setEditedTable,
    membershipLvls,
    currMinMembLvl,
    currMaxContacts
  } = props;

  const currentDate = new Date();

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteEvent, setDeleteEvent] = useState(currEvent);

  const handleDelete = (eventId) => {
    const body = new FormData();
    body.append("eventId", eventId);
    axios.post("/events/deleteEvent", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setUpdateTable(!updateTable);
        setOpenDeleteDialog(false);
      }
    });
  };

  function isEventInactive(e) {
    const eventDate = localDate(e.endDate);
    return currentDate > eventDate;
  }

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    if (!handleChange) {
    }
    else {
      setHandleChange(false);
    }
  }, [events]);

  useEffect(() => {
    setItemOffset(0);
  }, [updateOffset]);

  const setEventData = (event) => {
    setcurrEvent(event);
    setEventOffset(event.eventId);
  };

  function showDeleteDialog() {
    return (
      <Dialog open={openDeleteDialog}>
        <DialogTitle className="EventDelete-title mx-auto text-2xl font-bold font-brand-primary">
          Delete Event?
        </DialogTitle>
        <div className="EventDelete-buttonContainer flex justify-between px-8 mb-4">
          <button
            type="button"
            className="primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-2"
            onClick={() => handleDelete(deleteEvent.eventId)}
          >
            Delete
          </button>
          <button
            type="button"
            className="primary-button bg-brand-primary mb-2 h-11 pt-3 ml-2"
            onClick={() => {
              setOpenDeleteDialog(false);
            }}
          >
            Cancel
          </button>
        </div>
      </Dialog>

    );
  }

  const items = events.map((event, index) => (
    <div
      className={"EventButton-container flex p-2 rounded-md border-2 drop-shadow-2xl mb-2" + (event.eventId === currEvent.eventId ? " border-brand-primary" : "")}
      key={index}
    >
      {showDeleteDialog()}
      <div className="EventButton-leftContainer w-full flex flex-col">
        <button
          type="button"
          className="w-full h-full p-0 capitalize border-b last:border-b-0"
          onClick={() => setcurrEvent(event)}
        >
          <div className="EventButton-level text-base font-brand-primary flex mb-2">
            {Array.isArray(event.eventLevel) ?
              event.eventLevel.join(", ") :
              event.eventLevel}
          </div>
          <div className="EventButton-title text-xl font-bold font-brand-primary text-start flex mb-2">
            {event.event}
          </div>
          <div className="EventButton-level text-base font-brand-primary flex mb-2">
            {Array.isArray(event.eventType) ? event.eventType.join(", ") : event.eventType}
          </div>
          <div className="EventButton-company text-base font-brand-primary flex">
            {event.company}
          </div>
        </button>
      </div>
      <div className="StudentButton-rightContainer">
        {(userType === "admin") && (
          <button className="flex" onClick={() => {
            setDeleteEvent(event);
            setOpenDeleteDialog(true);
          }}>
            <CloseIcon fontSize="large" className="fill-brand-primary" />
          </button>
        )}

        {(userType === "admin" && !isEventInactive(event)) && (
          <EventEdit
            userType={userType}
            username={username}
            updateTable={updateTable}
            setUpdateTable={setUpdateTable}
            currEvent={event}
            setEventOffset={setEventOffset}
            membershipLvls={membershipLvls}
          />
        )}
      </div>
    </div>
  ));

  const itemsPerPage = 7;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
    if (events.length > newOffset) {
      setcurrEvent(events[newOffset]);
    }
  };

  if (events.length === 0) {
    return (
      <div className="EventTable bg-white p-2 mr-4 rounded-xl h-5/6">
        No events found.
      </div>
    );
  } else {
    return (
      <div className="EventTable bg-white p-2 mr-4 rounded-xl h-full" style={{ minHeight: "816px" }}>
        <ReactPaginate
          forcePage={currentPage}
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          className="flex w-full justify-between mb-6 mt-4 [&>li>a]:py-4 [&>li>a]:px-6 [&>li>a]:border [&>li>a]:rounded-lg [&>li.selected>a]:border-brand-primary"
        />
        <div className="EventTable-currentEvents overflow-y-auto">
          {currentItems}
        </div>
      </div>
    );
  }
}

EventTable.propTypes = {
  events: PropTypes.arrayOf({
    eventId: PropTypes.number,
    event: PropTypes.string,
    description: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    beginRegistrationDate: PropTypes.string,
    endRegistrationDate: PropTypes.string,
    expireDate: PropTypes.string
  }),
  currEvent: PropTypes.shape({
    eventId: PropTypes.number,
    event: PropTypes.string,
    description: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    beginRegistrationDate: PropTypes.string,
    endRegistrationDate: PropTypes.string,
    expireDate: PropTypes.string
  }),
  setcurrEvent: PropTypes.func,
  username: PropTypes.string,
  userType: PropTypes.string,
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  updateOffset: PropTypes.bool,
  setEventOffset: PropTypes.func,
  handleChange: PropTypes.bool,
  setHandleChange: PropTypes.func,
  currentPage: PropTypes.string,
  setCurrentPage: PropTypes.func,
  editedTable: PropTypes.bool,
  setEditedTable: PropTypes.func,
  membershipLvls: PropTypes.array,
  currMinMembLvl: PropTypes.string,
  currMaxContacts: PropTypes.array
};
EventTable.defaultProps = {
  events: [],
  currEvent: {},
  setcurrEvent: () => { },
  username: "",
  userType: "",
  updateTable: false,
  setUpdateTable: () => { },
  updateOffset: false,
  setEventOffset: () => { },
  handleChange: false,
  setHandleChange: () => { },
  currentPage: "",
  setCurrentPage: () => { },
  editedTable: false,
  setEditedTable: () => { },
  membershipLvls: [],
  currMinMembLvl: "",
  currMaxContacts: []
};
export default EventTable;
